import { useState } from 'react'

import { generateExcelFileName } from '@pages/Preview/helpers/generateExcelFileName'
import { toast } from '@utils/functions/notificationToast'

import type { AxiosError } from 'axios'
import type { ConsolidatedPreviewDetailsRequestProps } from '@services/api/preview/types'

import * as previewApi from '@services/api/preview'

export const useExportPreview = () => {
  const [isOpenConfirmExportPreview, setIsOpenConfirmExportPreview] = useState(false)
  const [exportConsolidatedPreviewLoading, setExportConsolidatedPreviewLoading] = useState(false)

  const exportConsolidatedPreview = async (payload: ConsolidatedPreviewDetailsRequestProps) => {
    setExportConsolidatedPreviewLoading(true)

    try {
      const response = await previewApi.exportConsolidatedPreview(payload)

      const fileName = generateExcelFileName(payload?.referenceDate!)
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)

      link.click()
      link.remove()

      toast.success('Exportação de Prévia realizada com sucesso!')
    } catch (error) {
      toast.error('Não foi possível exportar a Prévia. Tente novamente.', (error as AxiosError)?.status)
    } finally {
      setIsOpenConfirmExportPreview(false)
      setExportConsolidatedPreviewLoading(false)
    }
  }

  return {
    isOpenConfirmExportPreview,
    setIsOpenConfirmExportPreview,
    exportConsolidatedPreviewLoading,
    exportConsolidatedPreview
  }
}
